<div class="container">
  <div class="row align-items-center">
    <div class="col center-block">
      <p class="title"> Accès non autorisé</p>
    </div>
  </div>
</div>